module.exports = __webpack_public_path__ + "static/img/4.1e237fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/4.png
// module id = WfgV
// module chunks = 0